import React, { useEffect, useState } from 'react';

import type { Task } from '../services/taskService';
import {
  isRunningPlanningTask, planningTaskDuration, sharedPlanningTaskSeconds,
} from '../utils/planningTaskPresentation';

const timingTitle = (task: Task, duration: string): string => {
  if (!duration) return 'Execution time was not recorded for this task.';
  if (sharedPlanningTaskSeconds(task) !== null) {
    return 'Generation time of the shared component reused by this page; no separate generation was needed.';
  }

  return 'Total active time, including previous attempts; waiting time excluded';
};

export const PlanningTaskTiming: React.FC<{ task: Task }> = ({ task }) => {
  const [now, setNow] = useState(Date.now);
  const running = isRunningPlanningTask(task);

  useEffect(() => {
    if (!running) return undefined;
    const timer = window.setInterval(() => setNow(Date.now()), 1000);

    return () => window.clearInterval(timer);
  }, [running]);
  const duration = planningTaskDuration(task, now);

  return duration || task.status === 'done' ? <span className="task-card__completed-indicator"
    title={timingTitle(task, duration)}>{duration || 'Not recorded'}</span> : null;
};
